import * as React from 'react';

import { useUserContext } from 'common/contexts/UserContext';

export const Greeting: React.FC = () => {
  const user = useUserContext();
  const name = user.user?.first_name;

  const message = name ? `Hello ${name},` : 'Hello,';

  return <h1 className="font-bold">{message}</h1>;
};
Greeting.displayName = 'Greeting';
